import classNames from "classnames";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

// See: https://headlessui.com/react/menu
// See: https://mui.com/material-ui/react-menu/

type ListRootNode = HTMLUListElement;

export interface ListProps extends React.HTMLAttributes<ListRootNode> {
  disableBeams?: boolean;
}

const List = forwardRef<ListRootNode, ListProps>(({ children, className, disableBeams, ...props }, ref) => {
  return (
    <ul className={twMerge(classNames("py-2", { "py-0": disableBeams }, className))} ref={ref} {...props}>
      {children}
    </ul>
  );
});

List.displayName = List.name;

export default List;
